export default __webpack_public_path__ + "static/Blender-Medium-42470c791560fd20f0cd3f4a1c906677.woff2";